import React from 'react';

import { MODAL_NAMES } from '@constants/modalRenderers';
import { stateByKey } from '@constants/reportStates';

import useTranslation from '@hooks/useTranslation';

import type { IAIReport } from '@model/aiReport';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  report: IAIReport;
  controls?: {
    showEditReportBtn?: boolean;
    showWwEditReportBtn?: boolean;
    showResubmitReportBtn?: boolean;
    showWwResubmitReportBtn?: boolean;
  };
  actionItemId?: number | string;
}

const ReportAction: React.FC<IProps> = ({ report, controls, actionItemId }) => {
  const { t } = useTranslation();
  const { setActiveModal } = useModalActions();
  const reportState = stateByKey[report.state];

  if (
    (reportState !== 'Verifying' && reportState !== 'Declined') ||
    !(
      controls?.showEditReportBtn ||
      controls?.showWwEditReportBtn ||
      controls?.showResubmitReportBtn ||
      controls?.showWwResubmitReportBtn
    )
  ) {
    return null;
  }

  const handleOpenCompletionReportModal = () => {
    setActiveModal({
      name: MODAL_NAMES.completionReportModal,
      options: { actionItemId, controls },
    });
  };

  return (
    <span className={style.reportActionBtn} onClick={handleOpenCompletionReportModal}>
      {t(controls?.showEditReportBtn || controls?.showWwEditReportBtn ? 'Edit report' : 'Resubmit report')}
    </span>
  );
};

export default ReportAction;
